import { render, staticRenderFns } from "./CashShopBrowser.vue?vue&type=template&id=5c22b7cb&scoped=true&"
import script from "./CashShopBrowser.vue?vue&type=script&lang=ts&"
export * from "./CashShopBrowser.vue?vue&type=script&lang=ts&"
import style0 from "./CashShopBrowser.vue?vue&type=style&index=0&id=5c22b7cb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c22b7cb",
  null
  
)

export default component.exports